'use client';
var classes = {"root":"m_8bffd616"};

export { classes as default };
//# sourceMappingURL=Flex.module.css.mjs.map
